import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/page-images/line-break.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/page-images/overflow.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/page-images/post-image.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2022/page-images/updated.png");
